'use client';
import { APPlicationOSEnum, APPlicationStoreEnum, JWTTokenType, PostLocationType } from 'types';

const authToken = {
    key: 'ALO_EJARE_AUTH_TOKEN',
    get: function (): JWTTokenType | null {
        const data = localStorage.getItem(authToken.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: JWTTokenType) => {
        localStorage.setItem(authToken.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(authToken.key);
    },
};

const applicationOS = {
    key: 'ALOOEJARE_APPLICATION_OS',
    get: function (): APPlicationOSEnum | null {
        return localStorage.getItem(applicationOS.key) as APPlicationOSEnum;
    },
    set: (value: APPlicationOSEnum) => {
        localStorage.setItem(applicationOS.key, value);
    },
    remove: () => {
        localStorage.removeItem(applicationOS.key);
    },
};

const applicationStore = {
    key: 'ALOOEJARE_APPLICATION_STORE',
    get: function (): APPlicationStoreEnum | null {
        return localStorage.getItem(applicationStore.key) as APPlicationStoreEnum;
    },
    set: (value: APPlicationStoreEnum) => {
        localStorage.setItem(applicationStore.key, value);
    },
    remove: () => {
        localStorage.removeItem(applicationStore.key);
    },
};

const appDownloadTime = {
    key: 'ALOOEJARE_APP_DOWNLOAD_TIME',
    get: function (): boolean {
        const value = localStorage.getItem(appDownloadTime.key);
        const time = value ? Number(value) : null;
        return time ? new Date().getTime() - time > 24 * 60 * 60 * 1000 : true;
    },
    set: () => {
        localStorage.setItem(appDownloadTime.key, new Date().getTime().toString());
    },
    remove: () => {
        localStorage.removeItem(appDownloadTime.key);
    },
};

const lastPostLocation = {
    key: 'ALO_EJARE_LAST_POST_LOCATION',
    get: function (): PostLocationType | null {
        const data = localStorage.getItem(lastPostLocation.key);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    },
    set: (value: PostLocationType) => {
        localStorage.setItem(lastPostLocation.key, JSON.stringify(value));
    },
    remove: () => {
        localStorage.removeItem(lastPostLocation.key);
    },
};

export const __AppStorage = {
    authToken,
    applicationOS,
    applicationStore,
    appDownloadTime,
    lastPostLocation,
};
